import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useEffect, useState } from "react";
import { fetchApi } from "Config/fetchApi";
import { EncryptStorage } from "encrypt-storage";
import { Notify } from "Component/Notify";
import { handleError } from "Helper";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

function MapDashboard() {
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const [markerPositions, setMarkerPositions] = useState([]);

  // ==================== Pengaturan Pagination ==================== //
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [keywordSearch, setKeywordSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const yuridiksi_user_code = userInfo?.jurisdiction_level_code || "";
  const organisasi_user_id = userInfo?.organization_id || "";

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return new Intl.DateTimeFormat("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(date);
  };

  // ==================== Get Data ==================== //
  const getDataStreamingDevice = async () => {
    setIsLoading(true);
    try {
      const paramCari = `keywords=${keywordSearch}`;
      const paramPage = `page=${pageNumber}`;
      const paramSize = `size=${pageSize}`;
      const organizationParam = `organizationId=${yuridiksi_user_code === "N" ? "" : organisasi_user_id}`;
      const response = await fetchApi().get(
        `/operation/get-list?${paramCari}&${paramPage}&${paramSize}&${organizationParam}`
      );
      setMarkerPositions(response?.data?.data);
      setPageNumber(response.data.currentPage);
      setPageSize(response.data.size);
      setIsLoading(false);
    } catch (err) {
      setMarkerPositions([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  useEffect(() => {
    getDataStreamingDevice();
  }, []);

  return (
    <div className="relative w-full h-full">
      {/* Title Box */}
      <div className="absolute top-4 right-4 bg-white rounded-lg shadow px-4 py-2 z-[999]">
        <h2 className="text-gray-800 font-semibold text-sm">
          Operasi Berlangsung
        </h2>
      </div>

      {/* Map */}
      <MapContainer
        style={{ zIndex: 0 }}
        center={[-2.5, 117.5]}
        zoom={5}
        scrollWheelZoom={true}
        className="w-full h-full"
        minZoom={5}
        maxBounds={[
          [-11, 94],
          [6, 141],
        ]}
        attributionControl={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {markerPositions?.map((marker) => (
          <Marker
            key={marker?.id}
            position={[marker?.latitude, marker?.longitude]}
          >
            <Popup offset={[0, 55]}>
              <div>
                <div className="font-semibold pb-1 ">
                  {marker?.operation_name}
                </div>
                <div className="text-sm text-gray-600">
                  Mulai: {formatDate(marker?.operation_start_date)}
                </div>
                <div className="text-sm text-gray-600">
                  Selesai: {formatDate(marker?.operation_end_date)}
                </div>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}

export default MapDashboard;
